import { faUsers } from '@fortawesome/pro-light-svg-icons'

import { TeamModel } from '@domain-group/realhub-backend-api-types'

const generateTabBarItems = (team: TeamModel, editTeamUrl: string) => [
  {
    icon: faUsers,
    href: editTeamUrl,
    key: 'details',
    title: team?.title || 'User Details',
  },
]

export default generateTabBarItems
